<section class="single-select">
  <mat-form-field class="mat-select" appearance="fill">
    <mat-label>{{ data.label }}</mat-label>
    
    <input
      type="text"
      matInput
      placeholder="Pretraži..."
      [(ngModel)]="searchText"
      (ngModelChange)="filterOptions(searchText)"
      [matAutocomplete]="auto"
      #autoTrigger="matAutocompleteTrigger"
      (focus)="openOptions()"
    
    />

    <button 
      type="button"
      matSuffix 
      mat-icon-button 
      (click)="$event.stopPropagation(); openOptions(); autoTrigger.openPanel()" 
      style="border: none; background: transparent; cursor: pointer;">
      <mat-icon>arrow_drop_down</mat-icon>
    </button>

    <mat-autocomplete #auto="matAutocomplete" [displayWith]="displayFn" (optionSelected)="onOptionSelected($event.option.value)">
      <mat-option *ngFor="let option of filteredOptions" [value]="option">
        {{ option.label }}
      </mat-option>
      
      <mat-option *ngIf="filteredOptions.length === 0" disabled>
        Nema pronađenih rezultata
      </mat-option>
    </mat-autocomplete>
  </mat-form-field>
</section>